export interface JwtPayload {
  // Бэк отдаёт коды прав одним claim'ом — строкой через запятую ("1000022,1000023").
  // Массив поддерживаем на случай другого формата сериализации.
  permission_code?: number[] | string;
  // Маркер системного администратора: у него все права неявно, список кодов не передаётся.
  is_system_administrator?: boolean | string;
  [key: string]: any;
}

export function decodeJwt(token: string): JwtPayload | null {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) {
      return null;
    }

    const decoded = atob(parts[1].replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(decoded);
  } catch (error) {
    console.error('Failed to decode JWT', error);
    return null;
  }
}

function parsePermissionCodes(raw: number[] | string | undefined): number[] {
  if (raw === undefined || raw === null) {
    return [];
  }

  const values = Array.isArray(raw) ? raw : String(raw).split(',');
  return values
    .map(value => (typeof value === 'number' ? value : parseInt(String(value).trim(), 10)))
    .filter(code => !Number.isNaN(code));
}

export function getPermissionsFromToken(token: string): number[] {
  const payload = decodeJwt(token);
  return parsePermissionCodes(payload?.permission_code);
}

export function isSystemAdministratorFromToken(token: string): boolean {
  const payload = decodeJwt(token);
  const value = payload?.is_system_administrator;
  return value === true || value === 'true';
}

export function hasPermission(token: string, permissionCode: number): boolean {
  if (isSystemAdministratorFromToken(token)) {
    return true;
  }
  const permissions = getPermissionsFromToken(token);
  return permissions.includes(permissionCode);
}

export function hasAnyPermission(token: string, permissionCodes: number[]): boolean {
  if (isSystemAdministratorFromToken(token)) {
    return true;
  }
  const permissions = getPermissionsFromToken(token);
  return permissionCodes.some(code => permissions.includes(code));
}

export function hasAllPermissions(token: string, permissionCodes: number[]): boolean {
  if (isSystemAdministratorFromToken(token)) {
    return true;
  }
  const permissions = getPermissionsFromToken(token);
  return permissionCodes.every(code => permissions.includes(code));
}
